export default __webpack_public_path__ + "static/media/VisionMissionImg.2e835604.svg";